var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ backgroundImage: 'url(' + _vm.img + ')' }),attrs:{"id":"app"}},[_c('the-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }